import { render, staticRenderFns } from "./RegistrationReportSelectedFilter.vue?vue&type=template&id=728e2864&scoped=true"
import script from "./RegistrationReportSelectedFilter.vue?vue&type=script&lang=js"
export * from "./RegistrationReportSelectedFilter.vue?vue&type=script&lang=js"
import style0 from "./RegistrationReportSelectedFilter.vue?vue&type=style&index=0&id=728e2864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e2864",
  null
  
)

export default component.exports